import { gql } from "@apollo/client";

export const getPredefinedDataByTypes = gql`
  query GetPredefinedDataTypes($token: String!) {
    GetPredefinedDataTypes(token: $token)
  }
`;

export const AddPredefinedDataType = gql`
  mutation AddPredefinedDataTypeOnly(
    $token: String!
    $user_details: SubscribedUser!
    $data_type: String!
  ) {
    AddPredefinedDataTypeOnly(
      token: $token
      user_details: $user_details
      data_type: $data_type
    )
  }
`;

export const getPredefinedDataByType = gql`
  query GetPredefinedDataByType(
    $token: String!
    $type: String!
    $after: Cursor
    $first: Int
    $orderBy: PredefinedDataOrder
  ) {
    GetPredefinedDataByType(
      token: $token
      type: $type
      after: $after
      first: $first
      orderBy: $orderBy
    ) {
      edges {
        node {
          id
          type
          index
          value1
          value2
          value3
          value4
        }
        cursor
      }
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

export const PredefinedDataNode = gql`
  query PredefinedDataNode($ids: [ID!]!, $token: String!) {
    nodes(ids: $ids, token: $token) {
      ... on PredefinedData {
        id
        type
        index
        value1
        value2
        value3
        value4
      }
    }
  }
`;
